import get from 'lodash.get';
import { SECTIONS_BY_TYPE } from './searchBarConstants';

const getSectionPropsByType = type => get(SECTIONS_BY_TYPE, type) || {};

// analytics needs full `term` value for dealer storefront click through
const createSearchLink = (term, urlSection, urlLabel) => {
    const convertedValue = encodeURIComponent(term.toLowerCase());
    const href = urlSection && urlLabel
        ? `/${urlSection}/${urlLabel}/?search=${convertedValue}`
        : `/search/?q=${convertedValue}`;

    return href;
};

export {
    getSectionPropsByType,
    createSearchLink
};



// WEBPACK FOOTER //
// ./src/components/SearchBar/searchBarHelpers.js